import { defineMessages } from "react-intl";

const CREATE_USER_FORM = "create-user-form";

const createUserFormMessages = defineMessages({
  createAccount: {
    id: `${CREATE_USER_FORM}.create-account`,
    defaultMessage: "Create account"
  },
  unauthorized: {
    id: `${CREATE_USER_FORM}.unauthorized`,
    defaultMessage: "You are currently not authorized to create an account."
  },
  accountNotCreated: {
    id: `${CREATE_USER_FORM}.account-not-created`,
    defaultMessage: "The account could not be created."
  },
  acceptConsent: {
    id: `${CREATE_USER_FORM}.accept-consent`,
    defaultMessage:
      "I consent to the collection of specific data that allows EBSCO to provide me with a MyEBSCO account and related research functionality, as detailed in EBSCO’s <a>Privacy Policy</a>."
  },
  continueWithGoogle: {
    id: `${CREATE_USER_FORM}.continue-with-google`,
    defaultMessage: "Continue with Google",
    description: "Text for social auth link"
  },
  orContinueWithEmail: {
    id: `${CREATE_USER_FORM}.or-continue-with-email`,
    defaultMessage: "or continue with email",
    description:
      "text immediately after 'Continue with Google' button, showing the other way a user can create an account"
  }
});

export default createUserFormMessages;
